<template>

  <div class="rm" :ref="'rm_'+index">
    <div @click="selectRegistrationMethod(index)" class="rm-header row">
      <div class="row">
        <div class="col col-15 text-center"><input @input="selectRegistrationMethod(index)" class="input-radio" :id="'rm_'+index" name="rm" type="radio" :value="index"></div>
        <div class="col col-85">
          <label class="text-left" :for="'rm_'+index">
            <p class="mb-0 mt-0 lh-1-6"><strong>{{ registration_method.name }}</strong></p>
            <p class="mb-0 mt-0 text-16 lh-1-6" v-if="this.generateDescription(registration_method)">Welcome Guests</p>
          </label>
        </div>
      </div>
    </div>
        <div class="rm-form p-30" v-if="selected==index">
          <div v-if="registration_method.registration_method_id==3">
            <div class="row mb-15 p-rel">
              <input v-model="form.email_address" class="input-text rounded" type="text" placeholder="Email" />
            </div>
            <label for="email_consent" class="text-left d-flex align-items-start">
              <input class="mr-10" type="checkbox" name="email_consent" id="email_consent" v-model="form.email_consent" />
              <span class="text-16">I consent to receiving marketing and informational emails from The Muse New York.</span>
            </label>
            <label for="tos_consent" class="text-left d-flex align-items-start">
              <input class="mr-10" type="checkbox" name="tos_consent" id="tos_consent" v-model="form.tos_consent" />
              <span class="text-16">I consent to the terms of our <a href="https://www.themusehotel.com/privacy-policy/" target="_blank"><b>privacy policy.</b></a></span>
            </label>
          </div>
          <div v-if="registration_method.registration_method_id==4" class="row p-rel">
            <div class="row mb-15 p-rel">
              <input v-model="form.access_code" class="input-text rounded" type="text" placeholder="Access Code" />
            </div>
          </div>
          <div class="pt-20 mb-15">
            <button @click="emitRegistrationMethodData()" class="btn rounded" type="button" :style="'background: ' + color_background_button + '; color: ' + color_text_button">Continue</button>
          </div>
          <p v-show="show_continue" class="text-center text-14 mb-0">By clicking continue you agree to the
            <span @click="selectTermsOfService(index)" class="text-link"><b>Terms and Conditions</b></span>
          </p>
          <div v-show="show_continue" class="terms-of-service text-left pt-20" v-if="selected_tos==index">
            <div v-html="registration_method.terms_of_service"></div>
            <div class="mt-30 text-center"><button class="btn-close" @click="selectTermsOfService(null)">CLOSE</button></div>
          </div>
        </div>
      </div> <!-- rm -->



</template>
<script>
import Axios from "axios";
export default {
  name: 'registration_method',
  props: ['index','selected','selected_tos','color_background_button','color_text_button','registration_method','portal'],
  data(){
    return{
      clicked: false,
      cendyn: {
        form_id: 'FB8F3C36-97EA-4018-BA36-81811F23EC03',
        url: `https://web2.cendynhub.com/FormsRest/submit/`
      },
      form: {
        access_code: '',
        room_number: '',
        first_name: '',
        last_name: '',
        email_address: '',
        email_consent: true,
        tos_consent: true
      },
    }
  },
  computed: {
    show_continue:function(){
      const email_method_2_ready = this.registration_method.registration_method_id === 2 && this.form.last_name && this.form.room_number;
      const email_method_3_ready = this.registration_method.registration_method_id === 3 && this.form.email_address && this.form.last_name && this.form.first_name && this.form.tos_consent;
      const email_method_4_ready = this.registration_method.registration_method_id === 4 && this.form.access_code;
      return email_method_2_ready || email_method_3_ready || email_method_4_ready;
    },
  },
  watch: {
    'selected':function(){
      this.$el.querySelector( '#rm_' + this.index ).checked = (this.selected == this.index);
    }
  },
  mounted(){
    console.log(this.index)
    this.selected = 0
    this.$el.querySelector( '#rm_' + this.index ).checked = (this.selected == this.index);
  },
  methods: {
    // Generate the description that appears below the Registration Method name
    generateDescription:function(rm){
      if(rm.type!='rateplan') return null;
      var description = '';
      if (parseInt(rm.price)==0) {
        description += 'Connect';
      } else {
        description += '$' + rm.price;
      }

      description += ' for ';

      if(rm.duration>=1440){
        if(rm.duration % 1440 > 0){
          description += ' more than ';
        }
        var whole_days = Math.floor(rm.duration / 1440);
        description += whole_days + ' day'
        if(whole_days > 1){
          description += 's';
        }
      } else if(rm.duration>=60){
        if(rm.duration % 60 > 0){
          description += ' more than ';
        }
        var whole_hours = Math.floor(rm.duration / 60);
        description += whole_hours + ' hour'
        if(whole_hours > 1){
          description += 's';
        }
      } else {
        description += rm.duration + ' minute'
        if(rm.duration > 1){
          description += 's';
        }
      }

      description += ' with ';
      if(rm.additional_devices>0){
        description += 'up to ' + rm.additional_devices + ' devices';
      } else {
        description += '1 device';
      }
      if(rm.speed_upload && rm.speed_download){
        description += ' (' + rm.speed_upload + ' Up / ' + rm.speed_download + ' Down)';
      }
      return description;
    },
    // Send selected Registration Method back to parent
    selectRegistrationMethod:function(index){
      this.$emit('changeSelected', index);
    },
    // Send selected Terms of Service back to parent
    selectTermsOfService:function(index){
      this.$emit('changeSelectedTOS', index);
    },

    // Manipulate and send registration method data back to parent
    emitRegistrationMethodData: async function(){
      if(this.clicked){
        return;
      }
      this.clicked = true;


      var emitted = {
        registration_method_id: this.registration_method.registration_method_id,
        rateplan_id: null,
        email_address: null,
        access_code: null,
        email_opt_in: false
      };
       if (this.registration_method.registration_method_id=='3') {
        const registration_method = this.portal.registration_methods.find(registration_method => registration_method.registration_method_id === 3);
        const rateplan_id = registration_method.rate_plans[0].rateplan_id;
        emitted.rateplan_id = rateplan_id;
        emitted.email_address = this.form.email_address;
        emitted.email_opt_in = this.form.email_consent;

        if (this.form.email_consent) {
        // if user has agreed to marketing, post thru cendyn
        const cendynData = {
          PostData: {
            emailAddress: emitted.email_address
          }
        };
        Axios.post(this.cendyn.url + this.cendyn.form_id + '?format=json', cendynData).then(response => {
          this.$emit('emitRegistrationMethodData', emitted);
        }).catch( error => {
          this.$emit('error', 'Error registering with email address.');
        });
      } else {
        this.$emit('emitRegistrationMethodData', emitted);
      }


      } else if (this.registration_method.registration_method_id=='4') {
        emitted.access_code = this.form.access_code;
      }
      this.$emit('emitRegistrationMethodData', emitted);
    },
  }
}
</script>
<style scoped>
.btn {
  background: rgb(82, 179, 234);
  color: #ffffff; 
}
</style>
